(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('AlumnoController', AlumnoController);

    AlumnoController.$inject = ['$scope', '$state', 'Alumno', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AlumnoController ($scope, $state, Alumno, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.plan = plan();
        vm.alumno = alumno();
        vm.msjCerrado = false;
        
        loadAll();
//        var values = Object.keys(AlertService).map(function(it) { 
//        	   return AlertService[it]
//        	})
//        var evento = window.event;
//        console.log("esto hay:  "+values);
        function loadAll () {
        	Alumno.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.clases = data;
                vm.page = pagingParams.page;
                vm.msjCerrado=true;
            }
            function onError(error) {
                AlertService.error(error.data.message);
                vm.msjCerrado=false;
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function plan(){
        	return Alumno.getPlan();
        }
        
        function alumno(){
        	var aux = Alumno.getAlumno();
        	return aux;
        }
    }
})();
